import React, {
  Component,
  Suspense,
} from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import { SnackbarProvider } from 'notistack';
import RootStore from './stores/root-store';
import App from './App';
import './Main.css';
import PageLoading from './components/PageLoading/PageLoading';
import { toggleFeature } from './utils/feature-flags';
import { getRouterBasename } from './utils/get-router-basename';
import { ConfirmModalProvider } from './modules/modals/ConfirmModalManager';

const routerBasename = getRouterBasename();

class Main extends Component {
  componentDidMount() {
    // Expose toggling feature flags to the browser console
    window.toggleFeature = toggleFeature;
  }

  componentWillUnmount() {
    delete window.toggleFeature;
  }

  render() {
    const rootStore = new RootStore();

    return (
      <BrowserRouter basename={`${routerBasename}/`}>
        <Provider {...rootStore}>
          <ConfirmModalProvider>
            <SnackbarProvider maxSnack={3} preventDuplicate anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}>
              <Suspense fallback={<PageLoading />}>
                <App />
              </Suspense>
            </SnackbarProvider>
          </ConfirmModalProvider>
        </Provider>
      </BrowserRouter>
    );
  }
}

export default Main;
